import React, { useState, useEffect, useCallback, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import Input from '../../Components/Form/Input';
import FormCustom from '../../Components/Form/FormCustom';
import Button from 'react-bootstrap/Button'
import Select from '../../Components/Form/Select';
import Loading from '../../Components/Layout/Styled/Loading'
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';

const FacturamaGlobal = _ => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [data, setData] = useState({
        p_date_doc: '',
        p_id_branch_office: -1
    })
    const [isProcessingPending, setIsProcessingPending] = useState(true)
    const [dataPending, setDataPending] = useState({
        p_date_start: '',
        p_date_end: '',
    })

    const [isProcessingPendingSales, setIsProcessingPendingSales] = useState(true)
    const [dataPendingSales, setDataPendingSales] = useState({
        p_date_start: '',
        p_date_end: '',
    })
    const [branchOffices, setBranchOffices] = useState([])
    const [rows, setRows] = useState({})
    const [rowsPending, setRowsPending] = useState([])
    const [rowsPendingSales, setRowsPendingSales] = useState([])
    const [rowsSent, setRowsSent] = useState([])

    const [isProcessSent, setIsProcessSent] = useState(true)
    const [dataSent, setDataSent] = useState({
        p_date_start: '',
        p_date_end: '',
    })

    const [formatPay] = useState([
        { id: '01', name: 'Efectivo' },
        { id: '02', name: 'Cheque nominativo' },
        { id: '03', name: 'Transferencia electrónica de fondos' },
        { id: '04', name: 'Tarjeta de crédito' },
        { id: '05', name: 'Monedero electrónico' },
        { id: '06', name: 'Dinero electrónico' },
        { id: '08', name: 'Vales de despensa' },
        { id: '12', name: 'Dación en pago' },
        { id: '13', name: 'Pago por subrogación' },
        { id: '14', name: 'Pago por consignación' },
        { id: '15', name: 'Condonación' },
        { id: '17', name: 'Compensación' },
        { id: '23', name: 'Novación' },
        { id: '24', name: 'Confusión' },
        { id: '25', name: 'Remisión de deuda' },
        { id: '26', name: 'Prescripción o caducidad' },
        { id: '27', name: 'A satisfacción del acreedor' },
        { id: '28', name: 'Tarjeta de débito' },
        { id: '29', name: 'Tarjeta de servicios' },
        { id: '30', name: 'Aplicación de anticipos' },
        { id: '31', name: 'Intermediario pagos' },
        { id: '99', name: 'Por definir' },
    ])
    const [formatPaySelected, setFormatPaySelected] = useState('')

    const [formatPayFac] = useState([
        { id: 'PUE', name: 'PUE' },
        { id: 'PPD', name: 'PPD' },
    ])
    const [formatPaySelectedFac, setFormatPaySelectedFac] = useState('')

    const [selectedSales, setSelectedSales] = useState([]);

    /* const toggleSaleSelection = (id_document) => {
        setSelectedSales(prev => {
            if (prev.includes(id_document)) {
                return prev.filter(id => id !== id_document);
            } else {
                return [...prev, id_document];
            }
        });
    }; */

    const toggleSelectAllSales = () => {
        const allIds = rows.data.sales.map(s => s.id_document);
        const areAllSelected = allIds.every(id => selectedSales.includes(id));

        if (areAllSelected) {
            // Deseleccionar todos
            setSelectedSales([]);
        } else {
            // Seleccionar todos
            setSelectedSales(allIds);
        }
    };

    const allSalesSelected = useMemo(() => {
        if (!rows?.data?.sales) return false;
        const allIds = rows.data.sales.map(s => s.id_document);
        return allIds.length > 0 && allIds.every(id => selectedSales.includes(id));
    }, [rows.data, selectedSales]);

	const selectedSalesTotal = useMemo(() => {
		if (!rows?.data?.sales || selectedSales.length === 0) return 0;
		return rows.data.sales.reduce((acc, sale) => {
			if (selectedSales.includes(sale.id_document)) {
				const value = parseFloat(sale.total_doc);
				return acc + (isNaN(value) ? 0 : value);
			}
			return acc;
		}, 0);
	}, [rows?.data?.sales, selectedSales]);

    useEffect(() => {
        const loadRowsPending = async () => {
            if (isProcessingPending) {
                const response = await Controllers.facturama.get_sale_facturama_not_sent(dataPending)
                setRowsPending(response.data)
                setIsProcessingPending(false)
            }
        }

        loadRowsPending();
    }, [dataPending, isProcessingPending])

    useEffect(() => {
        const loadRowsPendingSales = async () => {
            if (isProcessingPendingSales) {
                const response = await Controllers.facturama.get_sales_to_send_facturama_has_invoice(dataPendingSales)
                setRowsPendingSales(response.data)
                setIsProcessingPendingSales(false)
            }
        }

        loadRowsPendingSales();
    }, [dataPendingSales, isProcessingPendingSales])

    useEffect(() => {
        const loadRowsPendingSales = async () => {
            if (isProcessSent) {
                const response = await Controllers.facturama.get_factura_global_sent(dataSent)
                setRowsSent(response.data)
                setIsProcessSent(false)
            }
        }

        loadRowsPendingSales();
    }, [dataSent, isProcessSent])

    useEffect(() => {
        Controllers.worker.get_worker_branch_office_public().then(res => {
            setBranchOffices([
                ...res.data.filter(f => f.id_type_money === 2)
            ])
        })
    }, [])

    const loadRows = _ => {
        setRows({})
        setIsProccesing(true)
        Controllers.facturama.get_sales_to_send_facturama(data).then(res => {
            setRows(res)
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }

    const branchOffice = useCallback(() => {
        if (!data.p_id_branch_office) {
            return ''
        }

        let findBranchOffice = branchOffices.find(w => parseInt(w.id_branch_office) === parseInt(data.p_id_branch_office))

        if (!findBranchOffice) {
            return ''
        }

        return {
            label: findBranchOffice.name_branch_office,
            value: findBranchOffice.id_branch_office
        }
    }, [data.p_id_branch_office, branchOffices])

    const cboFormatPay = useCallback(() => {
        if (!formatPaySelected) {
            return ''
        }

        let find = formatPay.find(w => w.id === formatPaySelected)

        if (!find) {
            return ''
        }

        return {
            label: find.name,
            value: find.id
        }
    }, [formatPaySelected, formatPay])

    const cboFormatPayFac = useCallback(() => {
        if (!formatPaySelectedFac) {
            return ''
        }

        let find = formatPayFac.find(w => w.id === formatPaySelectedFac)

        if (!find) {
            return ''
        }

        return {
            label: find.name,
            value: find.id
        }
    }, [formatPaySelectedFac, formatPayFac])

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'key_branch_office', text: 'Clave', align: 'center' },
                { name: 'name_branch_office', text: 'Sucursal', align: 'center' },
                { name: 'date_doc', text: 'Fecha', align: 'center' },
            ],
        ]}
        rows={rowsPending}
        isProcessing={isProcessingPending}
    />, [rowsPending, isProcessingPending])

    const dtRowsSent = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'date_doc', text: 'Fecha', align: 'center' },
                { name: 'key_branch_office', text: 'Clave', align: 'center' },
                { name: 'name_branch_office', text: 'Sucursal', align: 'center' },
                {
                    name: 'facturama_id', text: 'Factura', align: 'center', render: r => {
                        return <div className="align-self-center">
                            <a href={Helpers.config.apiUrl({
                                url: '/facturama/global/pdf/' + r.facturama_id
                            })} target='_blank' rel='noreferrer'>
                                <Button variant="danger" size='xs' className='align-self-center'>
                                    <i className='fa fa-file-pdf'></i>
                                </Button>
                            </a>
                        </div>
                    }
                },
            ],
        ]}
        columnOrder="date_doc"
        orderDirection="desc"
        rows={rowsSent}
        isProcessing={isProcessSent}
    />, [rowsSent, isProcessSent])


    const dtRowsSales = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'key_branch_office', text: 'Clave', align: 'center' },
                { name: 'name_branch_office', text: 'Sucursal', align: 'center' },
                { name: 'id_customers', text: 'ID Cliente', align: 'center' },
                { name: 'id_document', text: 'ID Venta', align: 'center' },
                { name: 'subtotal_doc', text: 'Subtotal', align: 'center' },
                { name: 'iva_doc', text: 'IVA', align: 'center' },
                { name: 'total_doc', text: 'Total', align: 'center' },
                { name: 'date_doc', text: 'Fecha', align: 'center' },
            ],
        ]}
        rows={rowsPendingSales}
        isProcessing={isProcessingPendingSales}
    />, [rowsPendingSales, isProcessingPendingSales])


    return <>
        <div className="form-row">
            <div className="col-lg-6 mb-3">
                <Card>
                    <Card.Header className="justify-content-between">
                        <span>Factura Global</span>
                    </Card.Header>
                    <Card.Body>
                        <FormCustom viewSubmit={false} onSubmit={_ => {
                            if (!data.p_id_branch_office) {
                                Helpers.toast.construct({
                                    response: 'warning',
                                    message: 'Seleccione una sucursal',
                                    toast
                                })
                                return false;
                            }

                            loadRows()
                        }}>
                            <Select
                                classNameParent="col-12 mb-2"
                                icon="fa fa-building"
                                text="Sucursal"
                                required
                                onChange={e => {
                                    setData({ ...data, p_id_branch_office: e.value })
                                }}
                                value={branchOffice()}
                                options={branchOffices.map(w => {
                                    return {
                                        label: w.name_branch_office,
                                        value: w.id_branch_office
                                    }
                                })}
                            />
                            <Input
                                classNameParent="col-12 mb-3"
                                type="date"
                                icon="far fa-calendar-alt"
                                placeholder="Fecha"
                                text="Fecha"
                                required
                                value={data.p_date_doc}
                                onChange={e => {
                                    setData({ ...data, p_date_doc: e.currentTarget.value })
                                }}
                            />
                            <div className="col-4 mb-2">
                                <Button type="submit" size="sm">
                                    <i className="fa fa-search"></i> Buscar
                                </Button>
                            </div>
                        </FormCustom>
                        {rows?.data && <>
                            <hr />
                            <div>
                                <div>Ventas a Facturar: <strong>{rows.data.total_sales}</strong></div>
                                <div>Fecha: <strong>{rows.data.date_doc}</strong></div>
                                <div>Status: <strong className={`text-${rows.data.color}`}>{rows.data.text}</strong></div>
                            </div>
                            {rows.data?.sales && rows.data.sales.length > 0 && (
                                <div className="mt-3">
                                    <h6>Detalle de Ventas</h6>
                                    <div className="table-responsive">
                                        <table className="table table-sm table-bordered">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th className="text-center">
                                                        <input
                                                            type="checkbox"
                                                            checked={allSalesSelected}
                                                            onChange={toggleSelectAllSales}
                                                        />
                                                    </th>
                                                    <th className="text-center">ID Venta</th>
                                                    <th>Cliente</th>
                                                    <th>Método de Pago</th>
                                                    <th className="text-right">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {rows.data.sales.map((sale, index) => (
                                                    <tr key={sale.id_document}>
                                                        <td className="text-center">
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedSales.includes(sale.id_document)}
                                                                onChange={() => {
                                                                    setSelectedSales(prev =>
                                                                        prev.includes(sale.id_document)
                                                                            ? prev.filter(id => id !== sale.id_document)
                                                                            : [...prev, sale.id_document]
                                                                    );
                                                                }}
                                                            />
                                                        </td>
                                                        <td className="text-center">{sale.id_document}</td>
                                                        <td>{sale.full_name_customers}</td>
                                                        <td>
                                                            {sale.first_payment}{sale.second_payment ? ', ' + sale.second_payment : ''}
                                                        </td>
                                                        <td className="text-right">{parseFloat(sale.total_doc).toFixed(2)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
										<tfoot>
											<tr>
												<td colSpan={4} className="text-right"><strong>Total seleccionadas ({selectedSales.length}):</strong></td>
												<td className="text-right"><strong>{selectedSalesTotal.toFixed(2)}</strong></td>
											</tr>
										</tfoot>
                                        </table>
                                    </div>
                                </div>
                            )}
                            {rows.data?.status === 'PENDING' && <div>
                                <Select
                                    classNameParent="mb-2"
                                    icon="fa fa-building"
                                    text="Forma de Pago"
                                    required
                                    onChange={e => {
                                        setFormatPaySelected(e.value)
                                    }}
                                    value={cboFormatPay()}
                                    options={formatPay.map(w => {
                                        return {
                                            label: w.name,
                                            value: w.id
                                        }
                                    })}
                                />
                                <Select
                                    classNameParent="mb-2"
                                    icon="fa fa-building"
                                    text="Forma de Pago Facturama"
                                    required
                                    onChange={e => {
                                        setFormatPaySelectedFac(e.value)
                                    }}
                                    value={cboFormatPayFac()}
                                    options={formatPayFac.map(w => {
                                        return {
                                            label: w.name,
                                            value: w.id
                                        }
                                    })}
                                />
                                <Button size="sm" variant='success' className='mt-2' onClick={_ => {
                                    if (!formatPaySelected) {
                                        Helpers.toast.construct({
                                            response: 'warning',
                                            message: 'Seleccione una forma de pago',
                                            toast
                                        })
                                        return false;
                                    }

                                    if (!formatPaySelectedFac) {
                                        Helpers.toast.construct({
                                            response: 'warning',
                                            message: 'Seleccione una forma de pago Facturama',
                                            toast
                                        })
                                        return false;
                                    }

                                    if (selectedSales.length === 0) {
                                        Helpers.toast.construct({
                                            response: 'warning',
                                            message: 'Seleccione al menos una venta',
                                            toast
                                        });
                                        return false;
                                    }

                                    setIsProccesing(true)
                                    Controllers.facturama.sales_to_send_facturama({
                                        p_id_branch_office: rows.data.id_branch_office,
                                        p_date_doc: rows.data.date_doc,
                                        p_payment_form: formatPaySelected,
                                        p_payment_form_facturama: formatPaySelectedFac,
                                        p_selected_sales: selectedSales,
                                    }).then(res => {
                                        Helpers.toast.construct({ toast, ...res })

                                        if (res.response === 'success') {
                                            setRows({})
                                        }
                                    }).catch(req => Helpers.promise.catch({ req, toast }))
                                        .finally(() => {
                                            setIsProccesing(false)
                                            setSelectedSales([])
                                            setFormatPaySelected('')
                                            setFormatPaySelectedFac('')
                                        })
                                }}>
                                    <i className="fa fa-check mr-2"></i>
                                    <span>Enviar a Facturama</span>
                                </Button>
                            </div>}
                        </>}
                    </Card.Body>
                </Card>
            </div>
            <div className="col-lg-6 mb-3">
                <Card>
                    <Card.Header className="justify-content-between">
                        <span>Factura Global Enviadas</span>
                    </Card.Header>
                    <Card.Body>
                        <FormCustom viewSubmit={false} onSubmit={_ => {
                            setIsProcessSent(true)
                        }}>
                            <Input
                                classNameParent="col-12 mb-3"
                                type="date"
                                icon="far fa-calendar-alt"
                                placeholder="Fecha Inicio"
                                text="Fecha Inicio"
                                required
                                value={dataSent.p_date_start}
                                onChange={e => {
                                    setDataSent({ ...dataSent, p_date_start: e.currentTarget.value })
                                }}
                            />
                            <Input
                                classNameParent="col-12 mb-3"
                                type="date"
                                icon="far fa-calendar-alt"
                                placeholder="Fecha Inicio"
                                text="Fecha Inicio"
                                required
                                value={dataSent.p_date_end}
                                onChange={e => {
                                    setDataSent({ ...dataSent, p_date_end: e.currentTarget.value })
                                }}
                            />
                            <div className="col-4 mb-2">
                                <Button type="submit" size="sm">
                                    <i className="fa fa-search"></i> Buscar
                                </Button>
                            </div>
                        </FormCustom>
                        {dtRowsSent}
                    </Card.Body>
                </Card>
            </div>
            <div className="col-md-6"></div>
            <div className="col-lg-6 mb-3">
                <Card>
                    <Card.Header className="justify-content-between">
                        <span>Factura Global Pendientes</span>
                    </Card.Header>
                    <Card.Body>
                        <FormCustom viewSubmit={false} onSubmit={_ => {
                            setIsProcessingPending(true)
                        }}>
                            <Input
                                classNameParent="col-12 mb-3"
                                type="date"
                                icon="far fa-calendar-alt"
                                placeholder="Fecha Inicio"
                                text="Fecha Inicio"
                                required
                                value={dataPending.p_date_start}
                                onChange={e => {
                                    setDataPending({ ...dataPending, p_date_start: e.currentTarget.value })
                                }}
                            />
                            <Input
                                classNameParent="col-12 mb-3"
                                type="date"
                                icon="far fa-calendar-alt"
                                placeholder="Fecha Inicio"
                                text="Fecha Inicio"
                                required
                                value={dataPending.p_date_end}
                                onChange={e => {
                                    setDataPending({ ...dataPending, p_date_end: e.currentTarget.value })
                                }}
                            />
                            <div className="col-4 mb-2">
                                <Button type="submit" size="sm">
                                    <i className="fa fa-search"></i> Buscar
                                </Button>
                            </div>
                        </FormCustom>
                        {dtRows}
                    </Card.Body>
                </Card>
            </div>
            <div className="col-md-6"></div>
            <div className="col-lg-6 mb-3">
                <Card>
                    <Card.Header className="justify-content-between">
                        <span>Factura Pendiente en Ventas</span>
                    </Card.Header>
                    <Card.Body>
                        <FormCustom viewSubmit={false} onSubmit={_ => {
                            setIsProcessingPendingSales(true)
                        }}>
                            <Input
                                classNameParent="col-12 mb-3"
                                type="date"
                                icon="far fa-calendar-alt"
                                placeholder="Fecha Inicio"
                                text="Fecha Inicio"
                                required
                                value={dataPendingSales.p_date_start}
                                onChange={e => {
                                    setDataPendingSales({ ...dataPendingSales, p_date_start: e.currentTarget.value })
                                }}
                            />
                            <Input
                                classNameParent="col-12 mb-3"
                                type="date"
                                icon="far fa-calendar-alt"
                                placeholder="Fecha Inicio"
                                text="Fecha Inicio"
                                required
                                value={dataPendingSales.p_date_end}
                                onChange={e => {
                                    setDataPendingSales({ ...dataPendingSales, p_date_end: e.currentTarget.value })
                                }}
                            />
                            <div className="col-4 mb-2">
                                <Button type="submit" size="sm">
                                    <i className="fa fa-search"></i> Buscar
                                </Button>
                            </div>
                        </FormCustom>
                        {dtRowsSales}
                    </Card.Body>
                </Card>
            </div>
        </div>
        <Loading show={isProcessing}>
            <Loading.Img src={Helpers.config.resourcesUrl({ url: '/images/dashboard/preloading.svg' })} alt="Preloading" />
        </Loading>
    </>
}

export default FacturamaGlobal